import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { getFromStorage, getSessionId } from '../../helpers/storageUtils';
import { UtilsService } from '../../services/utils.service';
import { PendingInvoicesApiResponse } from '../interfaces/pending-invoices.interface';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class PendinInvoiocesService {
  private http = inject(HttpClient);
  private readonly apiUrl = environment.URL_MEMBRESIA_SEGUNDO_COBRO;
  private tokenService = inject(TokenService);
  private sessionId: string = getFromStorage('session_id') || '0';
  private utils = inject(UtilsService);
  SESSION_ID = getSessionId().toString();
  /**
   * Obtiene todas las facturas pendientes de un usuario.
   * @param userId El ID del usuario para consultar.
   * @returns Un Observable con la respuesta de la API.
   */
  getInvoices(userId: string): Observable<PendingInvoicesApiResponse> {
    const headers = this.utils.getHeaders(this.sessionId || this.SESSION_ID); // Usamos el sessionId obtenido del almacenamiento local
    const url = `${this.apiUrl}/${userId}`;
    console.log(`[Service] Firing GET request to: ${url}`);

    // La llamada ahora usa this.http.get en lugar de of().
    return this.http.get<PendingInvoicesApiResponse>(url, { headers });
  }
}
